import DocPage from './components/DocPage'

export default function Instructions() {
    return <DocPage slug="instructions" path="/instructions" />
}
